<template>
	<div class="clients">
		<ul class="clients__list">
			<li
				v-for="(client, index) in clients"
				class="clients__item"
				:key="client.id + index"
			>
				<ClientCard
					:client="client"
					:search="search"
					@client-updated="handleClientUpdated(index, $event)"
				/>
			</li>
		</ul>
	</div>
</template>

<script>
import ClientCard from './client-card';

export default {
	name: 'ClientsList',
	components: {
		ClientCard
	},
	props: {
		clients: {
			type: Array,
			default: () => []
		},
		search: {
			type: String,
			default: ''
		}
	},
	methods: {
		handleClientUpdated(index, updatedClient) {
			this.$set(this.clients, index, updatedClient);
			this.$emit('change', this.clients);
			this.$emit('client-updated', {
				client: updatedClient,
				index: index
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.clients {
	&__item {
		margin-bottom: $gutter-md;
	}
}
</style>
